import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {capitalize} from "lodash-es";
import Chip from "../../../components/Chip";
import {SEVERITY_MAP} from "../../../models/options";

const SeverityChip = ({severity, ...otherProps}) => {
  const severityObj = SEVERITY_MAP[capitalize(severity)] || SEVERITY_MAP.None;

  return (
    <Chip
      className={classNames("severity-chip", "text-capitalize")}
      style={{
        color: severityObj.color,
        backgroundColor: severityObj.bgColor
      }}
      {...otherProps}>
      {severityObj.title}
    </Chip>
  );
};

SeverityChip.propTypes = {
  severity: PropTypes.string
};

export default SeverityChip;
